export type ActiveStatus =
  'IN_PROGRESS' | 'PENDING_APPROVAL' | 'ACTIVE' | 'SUNSETTING' | 'RETIRED' | 'INACTIVE' | 'VACANT';

export const ActiveStatuses = {
  IN_PROGRESS: 'IN_PROGRESS' as ActiveStatus,
  PENDING_APPROVAL: 'PENDING_APPROVAL' as ActiveStatus,
  ACTIVE: 'ACTIVE' as ActiveStatus,
  SUNSETTING: 'SUNSETTING' as ActiveStatus,
  RETIRED: 'RETIRED' as ActiveStatus,
  INACTIVE: 'INACTIVE' as ActiveStatus,
  VACANT: 'VACANT' as ActiveStatus,

  ALL: ['IN_PROGRESS', 'PENDING_APPROVAL', 'ACTIVE', 'SUNSETTING', 'RETIRED', 'INACTIVE', 'VACANT'] as ActiveStatus[],
};



// WEBPACK FOOTER //
// ./src/gs-core/common/models/active-status.ts